import Image from 'next/image';

const Logo = () => {
  return (
    <div>
      <Image src='/logo.svg' alt='logo' width={32} height={32} loading='lazy' />
    </div>
  );
};

export default Logo;
